import { create } from "zustand";

interface LoadingState {
  loadingStates: Record<string, boolean>;
  setLoadingState: (key: string, isLoading: boolean) => void;
  isAnyLoading: () => boolean;
  reset: () => void;
}

export const useLoadingState = create<LoadingState>((set, get) => ({
  loadingStates: {},
  setLoadingState: (key: string, isLoading: boolean) =>
    set((state) => ({
      loadingStates: {
        ...state.loadingStates,
        [key]: isLoading,
      },
    })),
  isAnyLoading: () => Object.values(get().loadingStates).some((state) => state),
  reset: () => set({ loadingStates: {} }),
}));
